import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon"

import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";

import MDTypography from "components/MDTypography";
import styles from "./index.module.css";

import { PATH, UPLOAD_PATH } from "../../constant";
import 'dayjs/locale/it';

import { DropzoneArea } from 'material-ui-dropzone';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';

import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import * as ajax from "helpers/ajax";
import dayjs from 'dayjs';
import Switch from '@mui/material/Switch';


export class CheckList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data:this.props.data
        };
    }

    componentDidMount = () => {
        if (this.state.data.file_path) {
            let formData = new FormData();
            formData.append("path", this.state.data.file_path);
            ajax.ajaxPost("/file_list.php", formData, this.listFilesCallback)
        }
        let el = document.querySelectorAll("[data-meta='MuiTypography']");
        el.forEach((x) => {
            x.disabled = true;
        });
    }

    listFilesCallback = (response) => {
        if (response.message.files.length <= 0) {
            let formData = new FormData();
            formData = {
                "data": { "file_path": null }
            };
            ajax.ajaxPutStrapi("gara-checklists/" + this.state.data.id, formData, this.saveCallback)
            this.saveBool(false);

            let temp = this.state.data;
            temp.file_path = null;
            this.setState({ data: temp }, this.callBack)
        }
    }

    saveFile = (files) => {
        if (files.length <= 0) { return; }

        let formData = new FormData();

        formData.append("path", "/gara/" + this.props.id + "/attività/"+this.props.subfolder);
        files.map((file, index) => {
            formData.append("file[]", file);
        })

        ajax.ajaxPost("/file_upload.php", formData)

        formData = {
            "data": { "file_path": "/gara/" + this.props.id + "/attività/" + this.props.subfolder }
        };
        ajax.ajaxPutStrapi("gara-checklists/" + this.state.data.id, formData, this.saveCallback)

        let temp = this.state.data;
        temp.file_path = "/gara/" + this.props.id + "/attività/" + this.props.subfolder;
        this.setState({ data: temp }, this.callBack)

        if (this.state.data.type == "file&calendar") {
            if (this.state.data.date) {
                this.saveBool(true)
            }
        } else {
            this.saveBool(true)
        }
    }

    saveBool = (val) => {
        let temp = this.state.data;
        temp.completed = val;
        this.setState({ data: temp }, this.callBack)

        let formData = {
            "data": { "completed": val }
        };
        ajax.ajaxPutStrapi("gara-checklists/" + this.state.data.id, formData, this.saveCallback)

    }

    callBack = () => {
        this.props.onChange(this.state.data);
    }

    saveData = (val, send = false) => {
        let temp = this.state.data;
        temp.date = val;
        this.setState({ data: temp })

        if (send) {
            let formData = {
                "data": { "date": val }
            };
            ajax.ajaxPutStrapi("gara-checklists/" + this.state.data.id, formData, this.saveCallback)
            if (this.state.data.type == "file&calendar") {
                if (this.state.data.file_path) {
                    this.saveBool(true)
                }
            } else {
                this.saveBool(true)
            }
        }
    }

    saveCallback = (response) => {
        //console.log(response)
    }


    render() {

        return (
            <MDBox py={2} container>
                <Grid container alignItems="center" className={styles.checklistContainer}>
                    <Grid item mr={2}>
                        <MDAvatar bgColor={this.state.data.completed ? "success" : "error"} size="xs">
                            <Icon fontSize="small">{this.state.data.completed?"done":"close"}</Icon>
                        </MDAvatar>
                    </Grid>

                    <Grid item xs={3}>
                        <MDTypography>{this.state.data.name}</MDTypography>
                    </Grid>


                    {((this.state.data.type == "file&calendar" || this.state.data.type == "file")) ?
                        <Grid item xs={4} mx={2}>
                            <DropzoneArea
                                onChange={(files) => { this.saveFile(files) }}
                                showFileNamesInPreview={true}
                                filesLimit={10}
                                dropzoneText={""}
                                dropzoneClass={this.state.data.file_path ? styles.dropzoneContainerComplete : styles.dropzoneContainer}
                                dropzoneParagraphClass={styles.dropzoneTextContainer}
                                icon={<Icon>person</Icon>}
                                showAlerts={false}
                                showPreviews={false}
                                showPreviewsInDropzone={false}
                            />
                        </Grid>
                        : null
                    }

                    {((this.state.data.type == "file&calendar" || this.state.data.type == "file")) ?
                        <Grid item mx={2}>
                            <MDButton color="warning" iconOnly onClick={() => this.props.openFileSystem()}>
                                <Icon>folder</Icon>
                            </MDButton>
                        </Grid>
                        : null
                    }


                    {(this.state.data.type == "file&calendar" || this.state.data.type == "calendar") ?
                        <Grid item xs={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"it"}>
                                <MobileDateTimePicker
                                    renderInput={(props) => (
                                        <MDButton variant={(this.state.data.date ? "gradient" : "outlined")} color={"info"} size="large" {...props}>
                                            {this.state.data.date ?
                                                dayjs(this.state.data.date).format("DD/MM/YYYY HH:mm")
                                                :
                                                <Icon>calendar_month</Icon>
                                            }
                                        </MDButton>
                                    )}
                                    label="Sopralluogo"
                                    onChange={(val) => this.saveData(val)}
                                    onAccept={(val) => this.saveData(val, true)}
                                    value={this.state.data.date}
                                    disablePast={true}
                                />
                            </LocalizationProvider>
                        </Grid>
                        : null
                    }

                    {(this.state.data.type == "boolean" || this.state.data.type == "file&calendar") ?
                        <Grid item mx={1}>
                            <Switch
                                checked={this.state.data.completed}
                                onChange={(val) => this.saveBool(val.target.checked)}
                            />
                        </Grid>
                        : null
                    }

                </Grid>


            </MDBox>
        )

    }
}

export default CheckList;


CheckList.defaultProps = {

}
